<template>
  <div class="menu-container">
    <div class="menu-bar">
      <div class="my-menu">
        <template v-if="showMenu">
         <img
          class="menu-img"
          @click="openMenu()"
          v-if="titleColor == '0' "
          src="@/assets/image/tbm/sidebar.png"
        />
         <img
          class="menu-img"
          @click="openMenu()"
          v-else
          src="@/assets/image/tbm/sidebar-gray.png"
        />

        </template>
        <template v-else>
          <img
          class="menu-img close-img"
          @click="closeMenu()"
          src="@/assets/image/tbm/menu_close.png"
        />
        </template>
        <div class="menu-text" :class="{makeColor:titleColor == '1'&&showMenu}" @click="goPage()" v-html="menuTitle"></div>
      </div>
    </div>
    <div
      :class="['dialog', !showMenu? 'show' : 'hide']"
      v-if="!showMenu"
      @touchmove.stop.prevent="moveHandle"
    >
      <div class="dialog-container">
        <ul class="menu-list">
          <li class="menu-item" v-for="(item,index) in returnData" :key="index">
            <a class tabindex="0" @click="menuGoPage(item)">{{item.name}}</a>
          </li>
        </ul>
        <goods :receiveData="goodList" v-if="goodList.length>1" :limit="4"></goods>
      </div>
    </div>
  </div>
</template>

<script>
import { checkLinkUrl } from "../../../utils/utils";
import goods from "./Goods";
export default {
  name: "Search",
  data() {
    return {
      currentIndex: null
    };
  },
  props: {
    showMenu: {
      type: Boolean,
      default: true
    },
    goodList: {
      type: null,
      observer: function(newVal, oldVal) {
        var that = this;
      }
    },
    newWindows: {
      type: Boolean,
      default: false
    },
    linkUrl: {
      type: String,
      default: ""
    },
    menuTitle: {
      type: String,
      default: ""
    },
    indexw: {
      type: String,
      default: ""
    },
    titleColor:{
      type: String,
      default: "0"
    },

    returnData: {
      type: null,
      observer: function(newVal, oldVal) {
        var that = this;
      }
    }
  },
  components: { goods },
  mounted() {
  },
  destroyed() {},
  methods: {
    goPage() {
      var that = this;
      let params = {
        newWindows: this.newWindows,
        link: this.linkUrl
      };
      checkLinkUrl(function(data) {}, params, that);
    },
    menuGoPage(item) {
      var that = this;
      let params = {
        newWindows: item.newWindows,
        link: item.linkUrl
      };
      checkLinkUrl(function(data) {}, params, that);
    },
    goDetail() {},
    //遮罩层穿透，阻止底部滑动
    moveHandle() {
      return;
    },
    showMask(index) {
      console.log("index", index);
      this.currentIndex = index;
      var temp = !this.showMenu;
      this.$emit("changeMenu2", temp);
    },
    openMenu(val) {
      this.$emit("changeMenu2", true);
    },
    closeMenu(val) {
      this.currentIndex = "";
      // this.$emit("changeMenu2", false);
    }
  }
};
</script>
<style lang="less" scoped>
.menu-container {
  display: block;
  .menu-bar {
    position: relative;
    z-index: 10;
    .my-menu {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;

      top: 3.2rem;
      left: 3.4rem;
      .menu-img {
        width: 3.3rem;
        height: 2.1rem;
        margin-bottom: 0rem;
        cursor: pointer;
        &.close-img {
          width: 2.5rem;
          height: 2.5rem;
          margin-right: 0.8rem;
          margin-bottom: 0;
        }
      }
      .menu-text {
        margin-left: 2rem;
        line-height: 1.2;
        cursor: pointer;
        color: #fff;
        transition: color 0.3s linear;
        text-align: left;
        max-width: 40rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: pre-line;
        font-family: "ArialNarrowBold";
        &.makeColor{
          color:#5C5D5F
        }

        &:hover {
          // color: white;
          text-decoration: underline;
        }
      }
    }
  }
}
.dialog {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  top: 0rem;
  overflow: hidden;
  // transition: opacity 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.75) !important;
  // &.show {
  //   background-color: rgba(0, 0, 0, 0.75) !important;
  // }

  .dialog-container {
    position: absolute;
    top: 8.7rem;
    right: 8.5rem;
    // left: 6.8rem;
    left: 8.5rem;
    text-align: left;
    max-height: 84rem;
    // overflow: auto;
    // margin-left: 2rem;
    .menu-list {
      width: 100%;
      margin-bottom: 3rem;
      margin-top: 1.2rem;
      display: flex;
      flex-flow: column wrap;
      .menu-item {
        padding: 0.5rem 0;
      }
      a {
        color: white;
        font-size: 2.8rem;
        line-height: 1;
        text-align: center;
        transition: color 0.3s linear;
        font-family: "ArialNarrowBold";
        &:hover {
          color: #969696;
          text-decoration: initial;
        }
      }
    }
    /deep/.save-btn {
      display: none;
    }
    /deep/.good-container {
      // height: 38rem;
      // max-height: 38rem;
      // overflow-y: auto;
      .goods-list {
        flex-flow: initial;
        // margin-right: -1.4rem;
        .goods-item {
          width: calc(25% - 2rem);
          // width: initial;
          // max-width: 25%;
          // max-width: 25%;
          margin-right: 3.4rem;
          margin: 0 3.4rem 0 0;
          &:nth-of-type(4) {
            margin-right: 0rem;
          }
          .product-sign {
            display: none;
          }
          .goods-name {
            padding: 3rem 0;
            font-size: 1.8rem;
            color: white;
            .name {
              margin-right: 2rem;
              transition: color 0.3s linear;
              &:hover {
                color: #5c5d5f;
              }
            }
            .price {
              display: none;
            }
          }
          :last-of-type {
            margin-right: 0;
            // border: 1px solid red;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .dialog .dialog-container {
    max-height: 60.5rem;
  }
}
@media screen and (max-width: 1440px) {
  .dialog .dialog-container {
    max-height: 50.5rem;
  }
}
@media screen and (max-width: 1240px) {
  .dialog .dialog-container {
    max-height: 40.5rem;
  }
}
@media screen and (max-width: 1024px) {
  .menu-container {
    display: block;
    .menu-bar {
      .my-menu {
        top: 3rem;
        left: 3rem;
        .menu-img {
          width: 2.6rem;
          height: 1.8rem;
        }
      }
    }
  }
  .dialog .dialog-container {
    max-height: 36.5rem;
    .menu-list .menu-item {
      padding: 0.3rem 0;
    }
  }
}
@media screen and (max-width: 768px) {
  .menu-container {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/MenuSlide.vue